import React, { useState } from "react"
import Grid from "@material-ui/core/Grid"
import "./windandwave.scss"
import Layout from "../components/layout"
import { makeStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import { Link } from "gatsby";
import PremiumServices from "../components/Sidebar/PremiumServices"
import Seo from "../components/seo"

const muiTheme = createTheme({
    overrides:{
      MuiSlider: {
        thumb:{
        borderRadius: "none",
        border: "2px solid white",
        height: 26,
        width: 26,
        marginTop: -13,
        marginLeft: -13,
        backgroundColor: "#bf0d0d",
        boxShadow:"0 0 10px rgba(0,0,0,.6)",
        '&:focus': {
          backgroundColor:"#007bff",
        }
      }, 
      root: {
        width:'92%'
      },
        track: {
          backgroundColor: 'rgb(61, 65, 67)',
          height: 16,
          marginTop: -8,
        },
        rail: {
          backgroundColor: 'rgb(32, 34, 35)',
          right: "-3px",
          height: 16,
          marginTop: -8,
        },
        markLabel: {
          fontSize: "19px",
        '@media (max-width: 778px)': {
          fontSize: "12px",
        },
        },
        // tooltip: {
        //   fontSize: "1em",
        //   color: "white",
        //   backgroundColor: "#bf0d0d",
        // },
      },
  }
  });
    
  const useStyles = makeStyles(theme => ({
    root: {
      width: "100%" + theme.spacing(3) * 2,
    },
    margin: {
      height: theme.spacing(3),
    },
  }));
  
  const marks = [
    {
      value: 0,
      label: 'T+0',
    },
    {
      value: 6,
      label: 'T+6',
    },
    {
      value: 12,
      label: 'T+12',
    },
    {
      value: 18,
      label: 'T+18',
    },
    {
      value: 24,
      label: 'T+24',
    },
    {
      value: 30,
      label: 'T+30',
    },
    {
      value: 36,
      label: 'T+36',
    },
    {
      value: 42,
      label: 'T+42',
    },
    {
      value: 48,
      label: 'T+48',
    },
  ];
  
  const CustomizedSlider = () => {
    const [newWaveValue, setNewWaveValue] = useState(0);
    const [optionValue, setOptionValue] = useState("Wind%20Waves%202018")
    
    const SliderImage1 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2049.png`;
    const SliderImage2 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2048.png`;
    const SliderImage3 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2047.png`;
    const SliderImage4 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2046.png`;
    const SliderImage5 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2045.png`;
    const SliderImage6 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2044.png`;
    const SliderImage7 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2043.png`;
    const SliderImage8 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2042.png`;
    const SliderImage9 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2041.png`;
    const SliderImage10 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2040.png`;
    const SliderImage11 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2039.png`;
    const SliderImage12 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2038.png`;
    const SliderImage13 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2037.png`;
    const SliderImage14 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2036.png`;
    const SliderImage15 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2035.png`;
    const SliderImage16 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2034.png`;
    const SliderImage17 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2033.png`;
    const SliderImage18 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2032.png`;
    const SliderImage19 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2031.png`;
    const SliderImage20 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2030.png`;
    const SliderImage21 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2029.png`;
    const SliderImage22 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2028.png`;
    const SliderImage23 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2027.png`;
    const SliderImage24 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2026.png`;
    const SliderImage25 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2025.png`;
    const SliderImage26 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2024.png`;
    const SliderImage27 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2023.png`;
    const SliderImage28 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2022.png`;
    const SliderImage29 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2021.png`;
    const SliderImage30 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2020.png`;
    const SliderImage31 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2019.png`;
    const SliderImage32 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2018.png`;
    const SliderImage33 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2017.png`;
    const SliderImage34 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2016.png`;
    const SliderImage35 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2015.png`;
    const SliderImage36 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2014.png`;
    const SliderImage37 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2013.png`;
    const SliderImage38 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2012.png`;
    const SliderImage39 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2011.png`;
    const SliderImage40 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2010.png`;
    const SliderImage41 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2009.png`;
    const SliderImage42 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2008.png`;
    const SliderImage43 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2007.png`;
    const SliderImage44 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2006.png`;
    const SliderImage45 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2005.png`;
    const SliderImage46 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2004.png`;
    const SliderImage47 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2003.png`;
    const SliderImage48 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2002.png`;
    const SliderImage49 = `${process.env.MET_WINDANDWAVE}/${optionValue}%2001.png`; 
  
    // const ValueLabelComponent = props => {
    //   const { children, open, value } = props;
    
    //   return (
    //     <ThemeProvider theme={toolTipTheme}>
    //     <Tooltip disableFocusListener={false} open={open} enterTouchDelay={0} placement="top" title={`T + ${value}`}>
    //       {children}
    //     </Tooltip>
    //     </ThemeProvider>
    //   );
    // }
  
    const classes = useStyles();
  
    const handleChange = (event, newValue) => {
      setNewWaveValue(newValue);
    };
  
    const handleOptionChange = event => {
      setOptionValue(event.target.value)
    }
    
    return (
      <React.Fragment>
        <div style={{ marginBottom:"20px"}}>
                  <label style={{display:"block", paddingBottom:"10px"}} htmlFor="wind">Select region:&nbsp; 
                    <select onBlur={handleOptionChange} onChange={handleOptionChange}  id="wind" name="wind">
                      <option value="Wind%20Waves%202018">English Channel</option>
                      <option value="Wind%20Wave%202018%20South">Bay of St Malo</option>
                      <option value="Wind%20Wave%202018%20North">Channel Islands</option>
                    </select>         
                  </label>
                </div>
      <div className={classes.root}>
        <div style={{marginLeft:"auto", marginRight:"auto", width:"90%"}}>
        
          <img style={newWaveValue === 0 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage1} alt="newwave1"/>
          <img style={newWaveValue === 1 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage2} alt="newwave2"/>
          <img style={newWaveValue === 2 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage3} alt="newwave3"/>
          <img style={newWaveValue === 3 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage4} alt="newwave4"/>
          <img style={newWaveValue === 4 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage5} alt="newwave5"/>
          <img style={newWaveValue === 5 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage6} alt="newwave6"/>
          <img style={newWaveValue === 6 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage7} alt="newwave7"/>
          <img style={newWaveValue === 7 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage8} alt="newwave8"/>
          <img style={newWaveValue === 8 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage9} alt="newwave9"/>
          <img style={newWaveValue === 9 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage10} alt="newwave10"/>
          <img style={newWaveValue === 10 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage11} alt="newwave11"/>
          <img style={newWaveValue === 11 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage12} alt="newwave12"/>
          <img style={newWaveValue === 12 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage13} alt="newwave13"/>
          <img style={newWaveValue === 13 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage14} alt="newwave14"/>
          <img style={newWaveValue === 14 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage15} alt="newwave15"/>
          <img style={newWaveValue === 15 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage16} alt="newwave16"/>
          <img style={newWaveValue === 16 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage17} alt="newwave17"/>
          <img style={newWaveValue === 17 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage18} alt="newwave18"/>
          <img style={newWaveValue === 18 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage19} alt="newwave19"/>
          <img style={newWaveValue === 19 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage20} alt="newwave20"/>
          <img style={newWaveValue === 20 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage21} alt="newwave21"/>
          <img style={newWaveValue === 21 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage22} alt="newwave22"/>
          <img style={newWaveValue === 22 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage23} alt="newwave23"/>
          <img style={newWaveValue === 23 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage24} alt="newwave24"/>
          <img style={newWaveValue === 24 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage25} alt="newwave25"/>
          <img style={newWaveValue === 25 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage26} alt="newwave26"/>
          <img style={newWaveValue === 26 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage27} alt="newwave27"/>
          <img style={newWaveValue === 27 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage28} alt="newwave28"/>
          <img style={newWaveValue === 28 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage29} alt="newwave29"/>
          <img style={newWaveValue === 29 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage30} alt="newwave30"/>
          <img style={newWaveValue === 30 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage31} alt="newwave31"/>
          <img style={newWaveValue === 31 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage32} alt="newwave32"/>
          <img style={newWaveValue === 32 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage33} alt="newwave33"/>
          <img style={newWaveValue === 33 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage34} alt="newwave34"/>
          <img style={newWaveValue === 34 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage35} alt="newwave35"/>
          <img style={newWaveValue === 35 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage36} alt="newwave36"/>
          <img style={newWaveValue === 36 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage37} alt="newwave37"/>
          <img style={newWaveValue === 37 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage38} alt="newwave38"/>
          <img style={newWaveValue === 38 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage39} alt="newwave39"/>
          <img style={newWaveValue === 39 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage40} alt="newwave40"/>
          <img style={newWaveValue === 40 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage41} alt="newwave41"/>
          <img style={newWaveValue === 41 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage42} alt="newwave42"/>
          <img style={newWaveValue === 42 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage43} alt="newwave43"/>
          <img style={newWaveValue === 43 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage44} alt="newwave44"/>
          <img style={newWaveValue === 44 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage45} alt="newwave45"/>
          <img style={newWaveValue === 45 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage46} alt="newwave46"/>
          <img style={newWaveValue === 46 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage47} alt="newwave47"/>
          <img style={newWaveValue === 47 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage48} alt="newwave48"/>
          <img style={newWaveValue === 48 && optionValue ? { display:'block'}:{display:'none'}} src={SliderImage49} alt="newwave49"/>     
        </div>
  
        <div className={classes.margin} /> 
        <ThemeProvider theme={muiTheme} >
        <div style={{width:"100%", textAlign:"center"}}>
        <Slider
          defaultValue={0}
          aria-labelledby="discrete-slider custom"
          step={1}
          valueLabelDisplay="off"
          // ValueLabelComponent={ValueLabelComponent}
          marks={marks}
          max={48}
          min={0}
          onChange={handleChange}
          value={newWaveValue}
        />
        </div>
        </ThemeProvider>
  
      </div>
      
      </React.Fragment>
    );
  }
  
const WindAndWave = () => {
  return (
    <React.Fragment>
      <Layout>
        <Seo title="Wind and wave map" description="Wind and wave forecast estimates for Jersey. Always use in conjunction with the official shipping forecast issued by Jersey Met." />
        <div className="forecastAutoMargin">
        <Grid item xs={12} sm={12} md={8} lg={8} className="menuTitle" style={{paddingLeft:0}}>
                  <h1>
                  Wind and wave map
                  </h1>                  
        </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={8} lg={8}>
              <React.Fragment>
              <article className="pagecontent">
              <div id="windWaveMap">
                <div style={{marginLeft:"auto", marginRight:"auto"}}>	
                  <CustomizedSlider/>               
                </div>

                <div style={{width:"100%"}}>
                  <p style={{ textAlign: "center", fontWeight:"600"}}>Model time</p>
                  <h3 >Forecasts are estimates only</h3>
                  <p>These are unverified computer generated products. Always use in conjunction with the&nbsp;
                  <Link className="shippingForcastFocusTest" activeClassName="" to='/shipping' style={{color:"#b60011"}}>official shipping forecast issued by Jersey Met.</Link></p>
                </div>
              </div>
            </article>
              </React.Fragment>
            </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                  <PremiumServices/>
                </Grid>
          </Grid>
        </div>
      </Layout>
    </React.Fragment>
  )
}
export default WindAndWave;
